import React from "react";
import { Form, Input, Row, Col, Checkbox, Button, Image, message } from "antd";
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { getRemember, setRemember, clearRemember } from "../../utils/Session";
import Net from "../../utils/net";
import config from "../../config";
import CryptoJS from "crypto-js";
import SHA256 from "crypto-js/sha256";
import "./style.css";

class Login extends React.Component {
    state = {
        focusItem: -1,//保存当前聚焦的input
        code: "",//验证码
        username: "",
        password: "",
        autoLogin: true
    };

    componentDidMount() {
        let rememberMe = getRemember();
        // console.log("rememberMe", rememberMe)
        if (rememberMe && rememberMe.autoLogin && rememberMe.user) {
            global.loginUser = rememberMe.user;
            this.goHome(rememberMe.user);
        }
    }

    goHome = (user) => {
        this.props.history.push({ pathname: "/sys/home" });
        setTimeout(() => {
            global.EE.emitEvent("MENU_CHANGE", ["/sys/home"]);
        }, 200)
        global.connectWs();
    };

    onFinish = (values) => {
        if (values.username === "" || values.password === "") {
            return message.warn("请输入用户名和密码");
        }
        this.loginSubmit(values);
    };

    onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    loginSubmit = (values) => {
        // e.preventDefault();
        this.setState({
            focusItem: -1
        });
        // this.formRef.validateFields().then(values => {
        let password = SHA256(values.username + values.password).toString(CryptoJS.enc.Hex);
        // password = "25f43b1486ad95a1398e3eeb3d83bc4010015fcc9bedb35b432e00298d5021f7";
        Net.post(global.ServerUrl + 'user/login', { loginName: values.username, password: password }, res => {
            // console.log("login", res);
            if (0 === res.result) {
                if (values.autoLogin) {
                    setRemember({
                        autoLogin: values.autoLogin,
                        autoLoginTime: new Date().getTime(),
                        user: res.ret
                    });
                }
                global.loginUser = res.ret;
                window.token = global.loginUser.token;
                localStorage.setItem('token', global.loginUser.token);
                this.goHome(res.ret);
            } else {
                message.error("用户名或密码错误，登录失败！");
            }
        }, error => {
            console.log('loginSubmit', error);
            message.error("连接服务器失败，请重新登录！");
        });
        // }).catch(errorInfo => {
        //     console.log(errorInfo);
        //         })
    };

    // changeCheck = (e) => {
    //     this.setState({ autoLogin: e.target.checked })
    // };

    render() {
        return (
            <div style={{
                position: 'fixed',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                width: '100%',
                height: '100%',
                zIndex: 99,
            }} className="wrap">
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                    <div style={{ minWidth: 500, width: '40%', margin: '0 auto', }}>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <div id="loginForm" style={{
                                backgroundColor: '#F8F8F8'
                            }}
                            >
                                <div style={{ padding: '10px 20px', fontSize: 15, color: '#000', fontWeight: 'bold', backgroundColor: '#EEE', textAlign: "center" }}>
                                    欢迎进入{config.title}，请登录！
                                </div>
                                <Form
                                    style={{ padding: 40, }}
                                    ref={comp => this.formRef = comp}
                                    initialValues={{
                                        autoLogin: this.state.autoLogin,
                                        username: this.state.username,
                                        password: this.state.password,
                                    }}
                                    onFinish={this.onFinish}
                                    onFinishFailed={this.onFinishFailed}
                                >
                                    <Form.Item
                                        style={{ marginBottom: 15 }}
                                        name="username"
                                        rules={[{ required: true, message: "请输入用户名" }]}
                                    >
                                        <Input
                                            onFocus={() => this.setState({ focusItem: 0 })}
                                            onBlur={() => this.setState({ focusItem: -1 })}
                                            maxLength={16}
                                            placeholder="请输入用户名"
                                            addonBefore={<UserOutlined />}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        style={{ marginBottom: 15 }}
                                        name="password"
                                        rules={[{ required: true, message: "请输入密码" }]}>
                                        <Input
                                            onFocus={() => this.setState({ focusItem: 1 })}
                                            onBlur={() => this.setState({ focusItem: -1 })}
                                            type="password"
                                            maxLength={16}
                                            placeholder="请输入密码"
                                            addonBefore={<LockOutlined />}
                                        />
                                    </Form.Item>
                                    <Row>
                                        <Col span={24}>
                                            <Form.Item style={{ marginBottom: 15 }} name="autoLogin" valuePropName="checked">
                                                <Checkbox
                                                    // onChange={this.changeCheck}
                                                    // checked={this.state.autoLogin}
                                                    style={{ color: "#424242" }}
                                                >自动登录</Checkbox>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <div className="bottom">
                                        <Button
                                            htmlType="submit"
                                            type="primary"
                                            style={{
                                                width: '100%',
                                                height: 40,
                                                backgroundColor: '#096dd9',
                                                color: '#FFF',
                                                border: 'none'
                                            }}
                                        // onClick={(e) => this.loginSubmit(e)}
                                        >登录</Button>
                                    </div>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Login
